export const dialogs = new Map();
